import { Outlet , useNavigate} from "react-router-dom"
import Header from "../Header/Header"
import { useContext, useEffect, useState , } from "react";
import { Context } from "../../Context/Context";
import { fetchAuthSession } from '@aws-amplify/auth';
import { TOKEN, checkIfLoggedInApi, profCasesPanelItems } from "../../Constants";
import axios from "axios";
import LoadingGauge from "Components/Icons/LoadingGauge";
import Footer from "Components/Header/Footer";

const Layout = () => {
    const navigate = useNavigate();
    const [isResponseReceived, setIsResponseReceived] = useState(false);
    const {updateLoggedinData, setUserDetails, userDetails, setShowLoading, setNotificationCount, selectedMenuItem, setSelectedMenuItem} = useContext(Context);
    const getUserDetails = async(accessToken) => 
    {
        if(accessToken)
        {
            try {
                setShowLoading(true);
                const data = await axios.get(checkIfLoggedInApi, {headers: {'Authorization': accessToken}});
                if({data})
                {
                    setShowLoading(false);
                    setUserDetails(data?.data);
                    setNotificationCount(data?.data?.notifications);
                    setIsResponseReceived(true);
                }
                else
                {
                    setShowLoading(false);
                    setIsResponseReceived(true);
                }
                
            }  
            catch (error)
            {
                setIsResponseReceived(true);
                console.log("session expired. login again")
                // navigate("/signin");
            }
        }
    }

    useEffect(() => 
    {
        fetchAuthSession().then((session) => {
            const accessToken = session.tokens.accessToken.toString();
            getUserDetails(accessToken);
        }
        ).catch(async(error) => {
            console.log("error", error)
            setIsResponseReceived(true);
            // remember a client's case link (e.g. from the "insights ready" email)
            // so sign-in can bring them straight back to it
            try {
                if (window.location.pathname.startsWith("/client/caseDetails/")) {
                    sessionStorage.setItem("qcr.returnTo", window.location.pathname + window.location.search);
                }
            } catch (e) { /* ignore */ }
            navigate("/signin");
        }
        );
    },[updateLoggedinData]);

    return (
    
         <div className={ "grid grid-cols-6 h-full auto-rows-max " }>
           
            {/* <Header /> */}
            {
                isResponseReceived ? 
            
            <><Outlet />
            {/* hidden on case-list pages: they show the footer beside their side menu (CaseListLayout) */}
            <div className="col-span-6 [.qcr-rail-footer_&]:hidden">
            <Footer/>
            </div>
            </>
            :
            <div className='mt-20'>
                <LoadingGauge/>
            </div>
            }
         </div>
    
    )
}

export default Layout;
